import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FormGroup from 'modules/User/Accounts/FormGroup'
import { Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'

const Accounts = () => {
  const { accounts: { accounts = {} } = {} } = useSelector((state) => ({
    accounts: state['user/accounts'],
  }))
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: 'USER/GET_USER_ACCOUNTS_CONNECTED' })
  }, [])

  return (
    <>
      <Typography
        component={'h3'}
        variant={'Subtitle-25'}
        className={'margin-bottom-16'}
      >
        {t('user::settings.accounts.heading')}
      </Typography>
      <form method="post">
        {Object.entries(accounts).length ? (
          Object.entries(accounts).map(([key, value]) => (
            <FormGroup key={key} profile={key} value={value} />
          ))
        ) : (
          <FormGroup />
        )}
      </form>
    </>
  )
}
export default Accounts
